import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import dynamic from 'next/dynamic';
import { useSearchInputContext, type SearchRefs } from 'src/common/components/Search/SearchInputProvider';
import LoadingSpinner from 'src/common/components/LoadingSpinner';
import { useSearchDateHandlers } from 'src/common/components/Search/useSearchDateHandlers';
import styles from './SheetDates.module.scss';

const DatesInputFilter = dynamic(() => import('src/common/components/DatesInputFilter'), {
  ssr: false,
  loading: () => <div className={styles.loading}><LoadingSpinner variant="l" /></div>,
});

type SheetDatesProps = {
  refs: Partial<SearchRefs>;
};
const SheetDates: FC<SheetDatesProps> = ({
  refs,
}) => {
  const [t] = useTranslation('common');
  const { filterDates } = useSearchInputContext();
  const {
    dateRangeOptions, handleDateFilterChange, rangeOption, highlightDates,
  } = useSearchDateHandlers(refs);

  return (
    <div
      aria-label={t('search--search-when-modal-title')}
      className={styles.root}
    >
      <DatesInputFilter
        dates={filterDates}
        dateRangeOptions={dateRangeOptions}
        rangeOption={rangeOption}
        showClearButton={false}
        highlightDates={highlightDates}
        classNameModifier="mainSearchPage"
        onChange={handleDateFilterChange}
        monthsShown={1}
        collapseLastRowIfEmpty
      />
    </div>
  );
};
export default SheetDates;
